import PhoneUtilManager from "google-libphonenumber";
export const phoneUtil = PhoneUtilManager.PhoneNumberUtil.getInstance();

export const validatePhone = (region: string, phone: string) => {
  if (!region || !phone) {
    return false;
  }

  return phoneUtil.isValidNumberForRegion(
    phoneUtil.parse(phone, region),
    region
  );
};
export const EmailRegx =
  /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/;

export const validateEmail = (email: string) => {
  if (!email) {
    return false;
  }
  return EmailRegx.test(email);
};

export const validateValidateCode = (code: string) => {
  const Reg = /^\d{6}$/;
  return Reg.test(code);
};

export const validatePrefixZeroPhone = (phone: string | undefined) => {
  // 去掉前缀0 00086 => +86
  try {
    if (phone === undefined) {
      return false;
    }
    // 移除空格
    const _phone = phone.replaceAll(" ", "");
    // 测试账号，跳过验证
    if (_phone.startsWith("0086000") && _phone.length === 15) {
      return true;
    }

    const phoneNum = "+" + parseInt(_phone, 10);
    const forValidNumber = phoneUtil.parseAndKeepRawInput(phoneNum);
    return phoneUtil.isValidNumber(forValidNumber);
  } catch (error) {
    return false;
  }
};

export const isNumeric = (str: any) => {
  if (typeof str != "string") return false;
  return !isNaN(str as any) && !isNaN(parseFloat(str));
};

export const checkIsPhone = (val: string) => {
  if (val.length > 2 && isNumeric(val)) {
    return true;
  }
  return false;
};
